// Weird setup to allow both Enum parameters, as well as literal strings
// https://stackoverflow.com/questions/51433319/typescript-constructor-accept-string-for-enum
const literal = (l) => l;
export const Network = {
    MAINNET: literal("mainnet"),
    TESTNET: literal("testnet"),
    REGTEST: literal("regtest"),
};
export const NFTCapability = {
    none: literal("none"),
    mutable: literal("mutable"),
    minting: literal("minting"),
};
//# sourceMappingURL=interface.js.map